module.exports = __webpack_public_path__ + "32f71730c41afa73c12944a44fa048cd.png";